export default {
    "tracker": "Измеритель настроения",
    "diary": "Дневник Эмоций",
}